import { useEffect, useRef } from "react";
import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
const AuthCallback = ({ setUser }) => {
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const run = async () => {
      const hash = window.location.hash || "";
      const match = hash.match(/session_id=([^&]+)/);
      const sessionId = match ? decodeURIComponent(match[1]) : null;
      if (!sessionId) {
        window.location.replace("/login");
        return;
      }
      try {
        const resp = await axios.post(`${API}/auth/google/session`, {
          session_id: sessionId,
        });
        localStorage.setItem("access_token", resp.data.access_token);
        localStorage.setItem("refresh_token", resp.data.refresh_token);
        localStorage.setItem("user", JSON.stringify(resp.data.user));
        setUser(resp.data.user);
        window.location.replace("/");
      } catch (e) {
        console.error("Google auth error:", e);
        window.location.replace("/login?google_error=1");
      }
    };
    run();
  }, [setUser]);

  return (
    <div className="min-h-screen bg-slate-50 flex items-center justify-center" data-testid="auth-callback-loading">
      <p className="text-slate-600 text-sm">Signing you in with Google…</p>
    </div>
  );
};

export default AuthCallback;
